import { createApi } from '@reduxjs/toolkit/query/react';
import Customization from 'models/Customization';
import { axiosBaseQuery } from 'services/api';

// Tags for cache invalidation
export const CUSTOMIZATION_TAG = 'Customization';

export const customizationApi = createApi({
  reducerPath: 'customizationApi',
  baseQuery: axiosBaseQuery({
    apiPath: '/api/customizations/',
  }),
  tagTypes: [CUSTOMIZATION_TAG],
  endpoints: builder => ({
    // Fetch a single customization
    getCustomization: builder.query({
      query: id => ({ url: `${id}/` }),
      transformResponse: response => new Customization(response),
      providesTags: (_result, _error, id) => [{ type: CUSTOMIZATION_TAG, id }],
    }),

    // Returns the customization based on the query params (usually the program id as `program`)
    listCustomizations: builder.query({
      query: params => ({ params }),
      transformResponse: response => response && new Customization(response),
      providesTags: [CUSTOMIZATION_TAG],
    }),

    // Update a customization
    updateCustomization: builder.mutation({
      query: ({ id, customization }) => ({
        url: `${id}/`,
        method: 'PATCH',
        data: customization,
      }),
      transformResponse: response => new Customization(response),
      invalidatesTags: [CUSTOMIZATION_TAG],
    }),

    // Upload a customization file (logo, favicon, etc.)
    uploadCustomizationFile: builder.mutation({
      query: ({ id, field, file }) => {
        const formData = new FormData();
        formData.append(field, file);
        return {
          url: `${id}/`,
          method: 'PATCH',
          data: formData,
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        };
      },
      transformResponse: response => new Customization(response),
      invalidatesTags: [CUSTOMIZATION_TAG],
    }),
  }),
});

export const {
  useGetCustomizationQuery,
  useListCustomizationsQuery,
  useUpdateCustomizationMutation,
  useUploadCustomizationFileMutation,
} = customizationApi;
